import React from "react";
import { Stack, Box, Typography, Chip } from "@mui/material";

const LEGEND_ITEMS = [
  { color: "#3B82F6", label: "Assigned to me" },
  { color: "#F59E0B", label: "Delegated to others" },
];

const STATUS_CHIPS = [
  { color: "#FEF3C7", textColor: "#92400E", label: "Pending" },
  { color: "#DBEAFE", textColor: "#1E40AF", label: "In Progress" },
  { color: "#D1FAE5", textColor: "#065F46", label: "Completed" },
  { color: "#F3F4F6", textColor: "#6B7280", label: "Cancelled" },
];

export default function CalendarLegend() {
  return (
    <Stack
      direction="row"
      spacing={3}
      alignItems="center"
      flexWrap="wrap"
      sx={{ rowGap: 1 }}
    >
      {LEGEND_ITEMS.map((item) => (
        <Stack key={item.label} direction="row" spacing={0.75} alignItems="center">
          <Box
            sx={{
              width: 14,
              height: 14,
              borderRadius: "4px",
              bgcolor: item.color,
            }}
          />
          <Typography variant="caption" fontWeight={500} color="text.secondary">
            {item.label}
          </Typography>
        </Stack>
      ))}
      <Box sx={{ width: 1, borderLeft: "1px solid", borderColor: "divider", height: 16 }} />
      {STATUS_CHIPS.map((chip) => (
        <Chip
          key={chip.label}
          label={chip.label}
          size="small"
          sx={{
            height: 22,
            fontSize: "0.68rem",
            fontWeight: 600,
            bgcolor: chip.color,
            color: chip.textColor,
          }}
        />
      ))}
    </Stack>
  );
}
